import React from 'react'

function Star({ fill = 'currentColor', size = 20 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 19"
    >
      <path
        fill={fill}
        d="M10 0l2.245 6.91h7.266l-5.878 4.27 2.245 6.91L10 13.82l-5.878 4.27 2.245-6.91L.49 6.91h7.266L10 0z"
      ></path>
    </svg>
  )
}

export default Star
